import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { SRLWrapper } from 'simple-react-lightbox';
import { getLanguage, getQueryString } from 'utils/params';
import { useLocation, useParams } from 'react-router-dom';
import {
  getDetailsHousingMaterials,
  getFeaturesHousingMaterials,
  getGalleriesProductHousingMaterials,
} from '../../aboutIsn.api';
import useFullPageLoader from '../../../commons/isn/useFullPageLoader';

const MaterialProductsContent = () => {
  const { t } = useTranslation();
  const language = getLanguage(useLocation());
  const params = useParams();
  const [detail, setDetail] = useState([]);
  const [features, setFeatures] = useState([]);
  const [galleries, setGalleries] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();

  const options = {
    settings: {
      disableWheelControls: true,
    },

    buttons: {
      backgroundColor: 'rgba(30,30,36,0.8)',
      iconColor: 'rgba(255, 255, 255, 0.8)',
      iconPadding: '10px',
      showAutoplayButton: false,
      showCloseButton: true,
      showDownloadButton: false,
      showFullscreenButton: false,
      showNextButton: true,
      showPrevButton: true,
      showThumbnailsButton: false,
      size: '43px',
    },

    thumbnails: {
      showThumbnails: false,
    },
  };

  useEffect(() => {
    showLoader();
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    getDetailsHousingMaterials(getQueryString({ language, id: params?.productid })).then(values => {
      if (values) {
        setDetail(values ?? []);
      }
    });

    getFeaturesHousingMaterials(getQueryString({ language, id: params?.productid })).then(values => {
      if (values) {
        setFeatures(values ?? []);
      }
    });

    getGalleriesProductHousingMaterials(getQueryString({ language, id: params?.productid })).then(values => {
      if (values) {
        setGalleries(values ?? []);
      }
    });
    //eslint-disable-next-line
  }, [params?.productid]);

  const _renderProductInfor = () => {
    hideLoader();
    if (detail) {
      return (
        <>
          <div className="col-lg-4 col-12">
            <div className={`product-image`}>
              <LazyLoadImage
                alt={`product`}
                src={`${process.env.REACT_APP_ISN_IMAGE_URL}${detail.imageUrl}`}
                effect="black-and-white"
                className="w-100 h-100"
              />
            </div>
          </div>
          <div className="col-lg-8 col-12">
            <div className="row mt-5 mt-lg-0">
              <div className="col-12">
                <p className="text-title">{detail.title}</p>
                <p
                  className="text-description"
                  dangerouslySetInnerHTML={{
                    __html: detail.content,
                  }}
                ></p>
              </div>
            </div>
            <div className="row">
              {/*
              <div className="col-lg-8 col-12">
                <ul className="list-advantages ml-3 ml-lg-0 ">
                  {detail.services && detail.services.map((el, index) => {
                    return (
                      <li key={`advantages${index}`}>{el.content}</li>
                    )
                  })}
                </ul>
              </div> */}
            </div>
          </div>
        </>
      );
    }
  };

  const _renderProductFeature = () => {
    hideLoader();
    if (features && features.length > 0) {
      return (
        <>
          <div className="col-8 offset-2 text-center mt-4">
            <p className="text-title">{t('about_isn.housing_material.lbl_superior_features')}</p>
            {/*<p className="text-description">{t('about_isn.housing_material.content_features')}</p>*/}
          </div>
          <div className="col-12">
            <div className="row flex justify-content-between">
              {features &&
                features.map((el, index) => {
                  return (
                    <div key={`feature${index}`} className="col-12 col-md-4 mb-5 mb-md-0">
                      <div className="card-feature text-center">
                        <LazyLoadImage
                          alt={`gallery${index}`}
                          src={`${process.env.REACT_APP_ISN_IMAGE_URL}${el.imageUrl}`}
                          effect="black-and-white"
                          className="w-100 h-100"
                        />
                        <p className="mt-4">
                          <strong>{el.title}</strong>
                        </p>
                        <p
                          className="text-description"
                          dangerouslySetInnerHTML={{
                            __html: el.content,
                          }}
                        ></p>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </>
      );
    }
  };

  const _renderGallery = () => {
    hideLoader();
    if (galleries && galleries.length > 0) {
      return (
        <>
          <div className="col-8 offset-2 text-center">
            <p className="text-title">{t('about_isn.housing_material.lbl_gallery')}</p>
            {/*<p className="text-description">{t('about_isn.housing_material.content_gallery')}</p>*/}
          </div>
          <div className="col-12">
            <SRLWrapper options={options}>
              <div className="row" style={{ paddingLeft: 15, paddingRight: 15 }}>
                {galleries &&
                  galleries.map((item2, index2) => {
                    return (
                      <div className="col-12 col-sm-3 px-0 text-center" key={index2}>
                        <LazyLoadImage
                          alt={`gallery${index2}`}
                          src={`${process.env.REACT_APP_ISN_IMAGE_URL}${item2.imageUrl}`}
                          effect="blur"
                          className="w-100"
                          style={{ height: '200px' }}
                        />
                      </div>
                    );
                  })}
              </div>
            </SRLWrapper>
          </div>
        </>
      );
    }
  };

  return (
    <>
      <div id="housingMaterialProduct">
        <div className="row mb-4">{_renderProductInfor()}</div>
        <div className="row mt-4">{_renderProductFeature()}</div>
        <div className="row mt-4">{_renderGallery()}</div>
      </div>
      {loader}
    </>
  );
};

export default MaterialProductsContent;
